import React from 'react';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Button, DialogActions, DialogContent, Grid } from '@material-ui/core';
import { Cancel, Done } from '@material-ui/icons';
import { RootState } from 'interfaces';
import { USER_OPERATIONS } from 'helper';
import { FormikTextFieldComponent } from 'components/Field';
import { TinymceEditor } from 'components/TinymceEditor';
import { useCreateOrUpdateArticle } from '../../hooks';
import { Confluence } from '../../interfaces';

const initialValues = {
  name: '',
  html: '',
};

const validationSchema = yup.object().shape({
  name: yup.string().required('Обязательное поле'),
  html: yup.string(),
});

interface IProps {
  article?: Confluence.IDefaultArticle | null;
  parentId?: number | null;
  onClose(): void;
  onCreateOrUpdate?(article: Confluence.IArticleBase): void;
}

const DefaultTemplate = ({ article, parentId, onClose, onCreateOrUpdate }: IProps) => {
  const operations = useSelector((state: RootState) => state.operations);

  const { loading, handleCreateOrUpdateDefaultArticle } = useCreateOrUpdateArticle(article, parentId, (articleData) => {
    onClose();
    if (onCreateOrUpdate) onCreateOrUpdate(articleData);
  });

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={article ?? initialValues}
      enableReinitialize
      onSubmit={(values) => handleCreateOrUpdateDefaultArticle({ ...values, html: values.html })}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Field
                  name="name"
                  variant="filled"
                  fullWidth
                  label="Заголовок статьи"
                  disabled={loading}
                  component={FormikTextFieldComponent}
                />
              </Grid>

              <Grid item xs={12}>
                <TinymceEditor
                  value={values.html || ''}
                  readOnly={loading}
                  placeholder="Введите текст статьи..."
                  onChange={(value) => setFieldValue('html', value)}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button variant="contained" disabled={loading} onClick={onClose} startIcon={<Cancel />}>
              Отменить
            </Button>

            {operations.includes(USER_OPERATIONS.CONFLUENCE_MANAGER) && (
              <Button color="primary" variant="contained" disabled={loading} type="submit" startIcon={<Done />}>
                {article ? 'Обновить' : 'Добавить'}
              </Button>
            )}
          </DialogActions>
        </Form>
      )}
    </Formik>
  );
};

export default DefaultTemplate;
